import { render } from "./MensagemForm.vue?vue&type=template&id=ef08a304"
import script from "./MensagemForm.vue?vue&type=script&lang=js"
export * from "./MensagemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__